import { useExplore } from "context/exploreContext";
import {
  IonItem,
  IonSelect,
  IonSelectOption,
  IonButton,
  IonButtons,
} from "@ionic/react";
import {
  Md2CloseBoxMultiple,
  Md2CloseCircleOutline,
  Md2CloseThick,
  Md2Cross,
  Md2FormatClear,
} from "react-icons-ng/md2";
import { classNames } from "utils/utils";
export default function ExploreFilter() {
  const {
    state: { leagues, league, gameTypes, gameType, gameRule, gameRules },
    dispatch,
  } = useExplore();

  async function callUpdateSelectedLeague(value) {
    dispatch({ type: "setLeague", value: value.value });
  }

  async function callUpdateGameType(value) {
    dispatch({ type: "setGameType", value: value.value });
  }
  async function callUpdateGameRule(value) {
    dispatch({ type: "setGameRule", value: value.value });
  }

  async function callClearFilter() {
    dispatch({ type: "setClearFilter" });
  }

  return (
    <div className="flex py-2 pl-2 w-full space-x-2 exploreFilters">
      <IonItem lines="none" className="w-full exploreFilterSelect">
        <div
          className={`relative w-full px-2 rounded-md ${
            league !== 0 ? "border-b-2 border-pink-500" : ""
          }`}
        >
          <IonSelect
            aria-label="League"
            interface="action-sheet"
            label-placement="stacked"
            label="League"
            className="custom-select"
            onIonChange={(e) => callUpdateSelectedLeague(e.detail)}
            value={league}
          >
            {leagues.map((league) => (
              <IonSelectOption key={league.id} value={league.id}>
                {league.title}
              </IonSelectOption>
            ))}
          </IonSelect>
        </div>
      </IonItem>
      <IonItem lines="none" className="w-full exploreFilterSelect">
        <div
          className={`relative w-full px-2 rounded-md ${
            gameType !== 0 ? "border-b-2 border-pink-500" : ""
          }`}
        >
          <IonSelect
            aria-label="GameType"
            interface="action-sheet"
            label-placement="stacked"
            label="Type"
            onIonChange={(e) => callUpdateGameType(e.detail)}
            value={gameType}
          >
            {gameTypes.map((gameType) => (
              <IonSelectOption key={gameType.id} value={gameType.id}>
                {gameType.title}
              </IonSelectOption>
            ))}
          </IonSelect>
        </div>
      </IonItem>
      <IonItem lines="none" className="w-full exploreFilterSelect">
        <div
          className={`relative w-full px-2 rounded-md ${
            gameRule !== 0 ? "border-b-2 border-pink-500" : ""
          }`}
        >
          <IonSelect
            aria-label="gameRule"
            interface="action-sheet"
            label-placement="stacked"
            label="Rule"
            onIonChange={(e) => callUpdateGameRule(e.detail)}
            value={gameRule}
          >
            {gameRules.map((gameRule) => (
              <IonSelectOption key={gameRule.id} value={gameRule.id}>
                {gameRule.title}
              </IonSelectOption>
            ))}
          </IonSelect>
        </div>
      </IonItem>
      <IonButtons>
        <IonButton
          detail="false"
          disabled={gameRule == 0 && gameType == 0 && league == 0}
          className={classNames(
            // gameRule !== 0 || gameType !== 0 || league !== 0 ? "" : "hidden",
            "customButton noOpacity"
          )}
          onClick={() => callClearFilter()}
          expand="block"
        >
          <Md2CloseBoxMultiple className="h-6 w-6 shrink-0 text-black" />
        </IonButton>
      </IonButtons>
    </div>
  );
}
